




























































import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
@Component({
    name: 'PathAlsTabBusCityInItem',
})
export default class PathAlsTabBusCityInItem extends Vue {
    @Prop() public curBusObjData: any;
    @Prop() public toBusTabItemClick: any;
    @Prop() public clickSameCityOverviewItem: any;
    @Prop() public clikSchemesItem: any;
    @Prop() public isShowPathAlsTabBusItem: any;

    constructor() {
        super();
    }

}
